export default [
  //   {
  //     path: 'detectionStat/:sn?',
  //     name: 'firefightingDetectionStat',
  //     component: () => import('@/views/firefighting/statistics/detection'),
  //     props: true,
  //     meta: {
  //       hidden: true,
  //       noPadding: true
  //     }
  //   },
  {
    path: 'alarmStat/:sn?',
    name: 'firefightingAlarmStat',
    component: () => import('@/views/firefighting/statistics/alarm'),
    props: true,
    meta: {
      hidden: true,
      noPadding: true
    }
  }
];
